(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var offerStages = [];
  var offerStageFrame = null;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  // Scale follows the stage's travel from the viewport bottom to 20% from the top.
  function updateOfferStage(stage) {
    if (reducedMotionQuery.matches) {
      stage.style.setProperty('--aspadz-footer-offer-scale', '1');
      return;
    }

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var stageTop = stage.getBoundingClientRect().top;
    var animationStart = viewportHeight;
    var animationEnd = viewportHeight * 0.2;
    var progress = clamp((animationStart - stageTop) / (animationStart - animationEnd), 0, 1);
    var scale = 0.6 + progress * 0.4;

    stage.style.setProperty('--aspadz-footer-offer-scale', scale.toFixed(4));
  }

  function updateOfferStages() {
    offerStageFrame = null;
    offerStages = offerStages.filter(function (stage) {
      if (!stage.isConnected) {
        return false;
      }

      updateOfferStage(stage);
      return true;
    });
  }

  function requestOfferStageUpdate() {
    if (offerStageFrame !== null) {
      return;
    }

    offerStageFrame = window.requestAnimationFrame(updateOfferStages);
  }

  function initOfferStage(root) {
    var stage = root.querySelector('.aspadz-footer__offer-stage');

    if (!stage || offerStages.indexOf(stage) !== -1) {
      return;
    }

    offerStages.push(stage);
    stage.classList.add('aspadz-footer__offer-stage--scroll-scale');
    updateOfferStage(stage);
  }

  function setPanelState(button, panel, expanded) {
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (mobileQuery.matches) {
      panel.hidden = !expanded;
      return;
    }

    panel.hidden = false;
  }

  function syncPanels(root) {
    root.querySelectorAll('.aspadz-footer__accordion-button').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));

      if (!panel) {
        return;
      }

      if (mobileQuery.matches) {
        setPanelState(button, panel, button.getAttribute('aria-expanded') === 'true');
      } else {
        panel.hidden = false;
      }
    });
  }

  function initFooter(root) {
    if (!root || root.dataset.aspadzFooterInitialized === 'true') {
      return;
    }

    root.dataset.aspadzFooterInitialized = 'true';
    initOfferStage(root);

    root.querySelectorAll('.aspadz-footer__accordion-button').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));

      if (!panel) {
        return;
      }

      setPanelState(button, panel, false);

      button.addEventListener('click', function () {
        if (!mobileQuery.matches) {
          return;
        }

        var shouldExpand = button.getAttribute('aria-expanded') !== 'true';

        root.querySelectorAll('.aspadz-footer__accordion-button').forEach(function (otherButton) {
          var otherPanel = document.getElementById(otherButton.getAttribute('aria-controls'));

          if (otherPanel && otherButton !== button) {
            setPanelState(otherButton, otherPanel, false);
          }
        });

        setPanelState(button, panel, shouldExpand);
      });
    });

    syncPanels(root);
  }

  function initAllFooters() {
    document.querySelectorAll('[data-aspadz-footer]').forEach(initFooter);
  }

  function syncAllFooters() {
    document.querySelectorAll('[data-aspadz-footer]').forEach(syncPanels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFooters);
  } else {
    initAllFooters();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncAllFooters);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncAllFooters);
  }

  window.addEventListener('scroll', requestOfferStageUpdate, { passive: true });
  window.addEventListener('resize', requestOfferStageUpdate);

  if (typeof reducedMotionQuery.addEventListener === 'function') {
    reducedMotionQuery.addEventListener('change', requestOfferStageUpdate);
  } else if (typeof reducedMotionQuery.addListener === 'function') {
    reducedMotionQuery.addListener(requestOfferStageUpdate);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFooter(event.target.querySelector('[data-aspadz-footer]'));
  });

  document.addEventListener('shopify:section:unload', requestOfferStageUpdate);
})();
